<template>
  <BaseModal
    v-model="model"
    size="md"
    :loading="loading"
    :showFooter="false"
  >
    <template v-if="currentView === 'question'">
      <h1 class="font-large-1 text-center pt-2">¿Actualizar condiciones?</h1>
      <div class="d-flex justify-content-center">
        <div>
          <div>
            <b-button
              variant="primary"
              block
              class="rounded-sm px-2 my-1"
              @click="offerRevision"
            >
              Si
            </b-button>
          </div>
          <div>
            <b-button
              variant="primary"
              block
              class="rounded-sm px-2 my-1"
              @click="currentView = 'no'"
            >
              No
            </b-button>
          </div>
          <div>
            <b-button
              variant="primary"
              block
              class="rounded-sm px-2 my-1"
              @click="currentView = 'byOffer'"
            >
              Por oferta
            </b-button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="currentView === 'no'">
      <div>
        <validation-observer ref="duration-input">
          <validation-provider
            v-slot="validationContext"
            name="duracion del contrato"
            rules="required"
          >
          <b-form-group
            label="Selecciona la duracion del contrato"
            label-for="contract-duration"
          >
            <BaseSelect
              id="contract-duration"
              http-method="get"
              :value="duration"
              :resource="$data.$constants.RESOURCES.RESOURCE_CONTRACT_DURATION"
              @input="duration = $event"
            />
            <small class="text-danger">{{ validationContext.errors[0] }}</small>
          </b-form-group>
          </validation-provider>
        </validation-observer>
        <b-button
          variant="primary"
          block
          class="rounded-sm px-2 my-1"
          @click="renewContract"
        >
          Renovar
        </b-button>
      </div>
    </template>
    <template v-if="currentView === 'byOffer'">
      <div>
        <validation-observer ref="by-offer-form">
          <validation-provider
            v-slot="validationContext"
            name="oferta de mantenimiento"
            rules="required"
          >
            <b-form-group
              label="Selecciona la oferta de mantenimiento"
              label-for="offer-select"
            >
              <BaseSelect
                id="offer-select"
                :value="selectedOffer"
                :resource="$data.$constants.RESOURCES.RESOURCE_OFFERS"
                :http-body="{ 'division_id': 3, client_id: job.client.id } "
                @input="selectedOffer = $event"
              />
              <small class="text-danger">{{ validationContext.errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider
            v-slot="validationContext"
            name="duracion del contrato"
            rules="required"
          >
            <b-form-group
              label="Selecciona la duracion del contrato"
              label-for="contract-duration-offer"
            >
              <BaseSelect
                id="contract-duration-offer"
                http-method="get"
                :value="duration"
                :resource="$data.$constants.RESOURCES.RESOURCE_CONTRACT_DURATION"
                @input="duration = $event"
              />
              <small class="text-danger">{{ validationContext.errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider
            v-slot="validationContext"
            name="Generar Facturación por"
            rules="required"
          >
            <b-form-group
              label="Generar Facturación por:"
              label-for="prorate_certification"
            >
              <v-select
                id="prorate_certification"
                :value="prorate_certification"
                :options="[
                  {
                    name: 'Prorratear el coste de la oferta entre revisiones',
                    value: 1,
                  },
                  { name: 'Por valor de revisión', value: 0 },
                ]"
                :reduce="(item) => item.value"
                label="name"
                @input="prorate_certification = $event"
              />
              <small class="text-danger">
                {{ validationContext.errors[0] }}
              </small>
            </b-form-group>
          </validation-provider>
        </validation-observer>
        <b-button
          variant="primary"
          block
          class="rounded-sm px-2 my-1"
          @click="renewByOffer"
        >
          Renovar
        </b-button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/ui/modal/BaseModal.vue";
import BaseSelect from "@/components/ui/select/BaseSelect.vue";
import JobContractsApi from '@/api/job-contracts-api'
import OffersApi from '@/api/offers-api'
import { mapGetters } from "vuex";

export default {
  name: "JobRenewContractModal",
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BaseModal,
    BaseSelect,
  },
  data() {
    return {
      loading: false,
      currentView: 'question',
      duration: null,
      selectedOffer: null,
      prorate_certification: null,
    };
  },
  computed: {
    ...mapGetters('job', {
      job: 'getJob',
    }),
    model: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          setTimeout(() => {
            this.currentView = 'question'
            this.duration = null
            this.selectedOffer = null
            this.prorate_certification = null
          }, 200)
        }
        this.$emit("input", value);
      },
    },
  },
  methods: {
    async offerRevision() {
      const { id, offer } = this.job
      const response = await OffersApi.check(offer.id)
      this.$router.push({ name: 'renewOfferJob', params: { id: response.data.id }, query: { job_id: id }})
    },
    async renewContract() {
      const validate = await this.$refs['duration-input'].validate()

      if (!validate) {
        return
      }

      this.loading = true
      const { id } = this.job
      try {
        await JobContractsApi.renewContract(id, { contract_duration: this.duration.id })
        window.location.reload()
      } finally {
        this.loading = false
      }
    },
    async renewByOffer() {
      const validate = await this.$refs['by-offer-form'].validate()

      if (!validate) {
        return
      }

      this.loading = true
      const { id } = this.job
      try {
        await JobContractsApi.renewOfferContract(id, {
          offer_id: this.selectedOffer.id,
          contract_duration: this.duration.id,
          prorate_certification: this.prorate_certification,
        })
        window.location.reload()
      } finally {
        this.loading = false
      }
    },
  },
};
</script>
